import { FieldInfo } from '@/pages/maps/contexts/region-context'

export const normalizeText = (text: string): string =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/[\p{P}\p{S}]/gu, '')
    .replace(/\s+/g, ' ')
    .trim()

export const filteredItems = (
  searchTerm: string,
  availableItems: FieldInfo[],
) => {
  if (!searchTerm) {
    return availableItems
  }

  const normalizedSearch = normalizeText(searchTerm)
  return availableItems.filter(({ field_name }) =>
    normalizeText(field_name).includes(normalizedSearch),
  )
}
